import { useSelector } from 'react-redux';

import { BuildingTech } from './BuildingTech';
import { selectBuildingCard } from 'shared/selectors/buildingCard';
import { getTechSection, isTechVisible } from 'shared/utils/buildingDetails';

export const BuildingTechContainer = () => {
  const card = useSelector(selectBuildingCard);
  const section = getTechSection(card);

  return section ? <BuildingTech section={section} isTechVisible={isTechVisible(card)} /> : null;
};
